import { Pipe, PipeTransform } from "@angular/core";
import { PaymentMethodEnum } from "@models/enums/payment-method.enum";

@Pipe({
  name: "paymentMethod",
  standalone: true,
})
export class PaymentMethodPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case PaymentMethodEnum.CREDIT_CARD:
      case "credit": // Historical PDV / installed APK compatibility.
        return "Cartão de crédito";
      case PaymentMethodEnum.DEBIT_CARD:
        return "Cartão de débito";
      case PaymentMethodEnum.PIX:
        return "PIX";
      case PaymentMethodEnum.CASH:
        return "Dinheiro";
      case PaymentMethodEnum.GRATUITO:
        return "Gratuito";
      default:
        return value;
    }
  }
}
